import { createFileRoute } from '@tanstack/react-router'

import type { Language } from '@orus.eu/translations'

import { SignEndorsementPageV2 } from '../../../../components/pages/sign-endorsement-v2-page.tsx'

export const Route = createFileRoute('/s/e-v2/$token')({
  component: SignEndorsementPageV2,
  validateSearch: (search: Record<string, unknown>) => ({
    lg: search['lg'] as Language | undefined,
  }),
})
